export enum ConfigManagerProperties {
  refreshModuleBoardMin = 'refreshModuleBoardMin',
  dynamicDAGDisabled = 'dynamicDAGDisabled',
  moduleGroupManagementRoute = 'moduleGroupManagementRoute',
  moduleGroupsWorkbenchRoute = 'moduleGroupsWorkbenchRoute',
}
